import { Component, OnInit, Input, Output, ViewChild, EventEmitter, SimpleChanges } from '@angular/core';
import { FormularioServicioComponent } from './formulario-servicio/formulario-servicio.component';

@Component({
  selector: 'app-listado-servicios',
  templateUrl: './listado-servicios.component.html',
  styleUrls: ['./listado-servicios.component.scss']
})
export class ListadoServiciosComponent implements OnInit {
    
    public usar_renta:boolean=false;
    public servicio: any= {
        activo: true,
        periodicidad: ""
    };
    @Input() public contrato: any = {};

    @ViewChild(FormularioServicioComponent) formulario_servicio:FormularioServicioComponent;
    @Output() contratoGuardado: EventEmitter<any> = new EventEmitter;

    public loading:boolean=false;

    ngOnInit() {
    }
    
    ngOnChanges(changes: SimpleChanges) {
        if ( changes.contrato && this.contrato ) {
            //Configura el formulario de servicio con los valores defaults
            this.nuevoServicio();          
        }
    }

    public loadServicio(servicio){
        console.log("#loadServicio");
        this.servicio = servicio;
        var parent = this;
        setTimeout(function(){
            parent.formulario_servicio.loadServicio(servicio);
        },500);
    }

    public guardarServicio($event){
        var servicio_recibido = $event;
        if(servicio_recibido.id_servicio && servicio_recibido.id_servicio!=0){
            for(var i=0;i<this.contrato.servicios.length;i++){
                var r = this.contrato.servicios[i];
                if(r.id_servicio==servicio_recibido.id_servicio){
                    this.contrato.servicios[i] = servicio_recibido;
                }
            }
        }else{
            this.contrato.servicios.push($event);
        }
        this.guardarContrato(false);

        //Configura el formulario de servicio con los valores defaults
        this.nuevoServicio();
    }

    eliminarServicio(index){
        if(confirm("¿Estás seguro que deseas eliminar este servicio?")){
            for(var i=0;i<this.contrato.servicios.length;i++){
                if(index==i){
                    this.contrato.servicios.splice(i,1);
                }
            }
            this.guardarContrato(false);
        }
    }

    guardarContrato(go_to_next_page){
        this.loading = true;
        var parent = this;
        if(this.contratoGuardado){
          this.contratoGuardado.emit(
              {
                  go_to_next_page:go_to_next_page, 
                  contrato:this.contrato,
                  callback: function(){
                    parent.loading = false;
                    parent.nuevoServicio();
                  }
                });
        }
      }

    public nuevoServicio(){
        this.formulario_servicio.configurarFormNuevoServicio();
    }

}


// WEBPACK FOOTER //
// ./src/app/components/contratos/agregar-contrato/listado-servicios/listado-servicios.component.ts